// @flow
import ZoneListContainer from './containers/ZoneListContainer';

export default ZoneListContainer;